import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* getSaleOrderHistory(action) {
  const {
    data: {
      filterObj,
      page,
      pageSize,
      locationVisibility,
      materialVisibility,
      accessToken,
    },
  } = action.payload

  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/sale-order-history/get-history`,
        {
          filterObj,
          page,
          pageSize,
          locationVisibility,
          materialVisibility,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
    )
    yield put(actions.getSaleOrderHistory.success(response.data))
  } catch (error) {
    yield put(actions.getSaleOrderHistory.failure())
  }
}

export default function* watchSaleOrderHistory() {
  yield all([
    takeEvery(actions.GET_SALE_ORDER_HISTORY.REQUEST, getSaleOrderHistory),
  ])
}

export { getSaleOrderHistory }
